import { Navigate } from "react-router-dom";
import useAuth from './UseAuth';

export const RequireClaims = ({ children, role }) => {
    const { user, login } = useAuth();

    if (user?.userId) {
        if (role === undefined || role.length === 0) {
            // No role is required
            return children;
        }
        else if (user.roles.some(x => role.includes(x))) {
            // User has role
            return children;
        }
        else {
            // User doesn't have role
            return <Navigate to="/Unauthorized" replace />;
        }
    } else {
        // User is not yet authenticated
        login();

        return null;
    }
};
